// Circular avatar: the uploaded picture when present, else an initials circle.
// Single reusable surface across community (members, chat) + the app nav.
// Mirrors iOS AvatarView.
import { cx } from "./ui";

export function Avatar({
  url,
  name,
  size = 36,
  className,
}: {
  url?: string | null;
  name: string;
  size?: number;
  className?: string;
}) {
  const initial = (name.trim()[0] || "?").toUpperCase();
  if (url) {
    return (
      <img
        src={url}
        alt={name}
        className={cx("shrink-0 rounded-full object-cover", className)}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <span
      className={cx(
        "flex shrink-0 items-center justify-center rounded-full bg-brand-100 font-bold text-brand-700",
        className,
      )}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.4) }}
    >
      {initial}
    </span>
  );
}
